import React from "react";
import LandingHeader from "../components/layout/LandingHeader";
import LandingFooter from "../components/layout/LandingFooter";
import { Button } from "../components/ui";
import {
  ArrowDown,
  Check,
  QrCode,
  CreditCard,
  Lock,
  Key,
  Database,
  Server,
  Eye,
  ArrowRight,
} from "lucide-react";

function Recursos() {
  const logo = (
    <img
      src={require("../statics/img/escudo-verde.png")}
      alt="logo"
      height="50"
      className="mr-2 h-12"
    />
  );

  return (
    <div className="min-h-screen flex flex-col bg-urb-dark text-slate-100 selection:bg-urb-primary selection:text-black">
      <LandingHeader />

      <main className="flex-1">
        {/* Hero Section */}
        <section className="py-12 px-4 md:px-8 max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 items-center gap-10">
          <div className="flex flex-col gap-4">
            <span className="font-semibold text-xs sm:text-sm tracking-wider uppercase text-urb-primary">
              TECNOLOGIA COMPLETA
            </span>
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-black m-0 leading-tight">
              RECURSOS QUE LEVAM <br className="hidden md:inline" />
              SEU EVENTO{" "}
              <span className="text-urb-primary drop-shadow-[0_0_12px_rgba(138,230,0,0.3)]">
                A OUTRO NÍVEL.
              </span>
            </h1>
            <p className="text-slate-400 text-base sm:text-lg m-0 leading-relaxed max-w-lg">
              Da gestão à linha de chegada, tudo que você precisa para criar
              experiências inesquecíveis para atletas e organizadores.
            </p>
            <div className="flex mt-2">
              <Button
                variant="primary"
                size="lg"
                className="font-bold text-sm uppercase px-6 py-3 flex items-center gap-2"
                onClick={() => {
                  const el = document.getElementById("features-grid");
                  if (el) el.scrollIntoView({ behavior: "smooth" });
                }}
              >
                <ArrowDown className="w-4 h-4" />
                EXPLORAR TODOS RECURSOS
              </Button>
            </div>
          </div>

          {/* Right Hero Graphic */}
          <div className="flex justify-center mt-4 lg:mt-0 relative">
            <div
              className="h-80 w-full rounded-2xl overflow-hidden shadow-2xl border border-urb-border relative flex items-center justify-center group"
              style={{
                background:
                  "linear-gradient(to bottom, rgba(0,0,0,0.6), rgba(0,0,0,0.9)), url('https://images.unsplash.com/photo-1502224562085-639556652f33?auto=format&fit=crop&w=800&q=80') center/cover",
              }}
            >
              <div className="text-3xl py-2 px-4 z-10">{logo}</div>
              <div className="absolute bottom-0 w-full p-4 text-center z-10 bg-gradient-to-t from-black/90 to-transparent">
                <span className="font-mono text-lg text-urb-primary tracking-widest font-black">
                  READY TO RUN
                </span>
              </div>
            </div>
          </div>
        </section>

        {/* Grid of Features (01 to 08) */}
        <section
          id="features-grid"
          className="py-12 px-4 md:px-8 border-t border-urb-border"
        >
          <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* 01. Dashboard Inteligente */}
            <div className="bg-urb-card/70 border border-urb-border hover:border-urb-primary/50 transition-all duration-300 rounded-2xl p-6 flex flex-col md:flex-row gap-6">
              <div className="flex-1 flex flex-col gap-3">
                <span className="inline-block px-3 py-1 rounded-full bg-urb-primary/10 border border-urb-primary/30 text-urb-primary font-mono text-xs font-bold w-fit">
                  01. DASHBOARD INTELIGENTE
                </span>
                <p className="text-xs text-slate-400 m-0">
                  Tenha uma visão completa do seu evento em tempo real.
                </p>
                <ul className="flex flex-col gap-2 p-0 m-0 list-none text-xs text-slate-200">
                  <li className="flex items-center gap-2">
                    <Check className="w-3.5 h-3.5 text-urb-primary shrink-0" />
                    Inscritos em tempo real
                  </li>
                  <li className="flex items-center gap-2">
                    <Check className="w-3.5 h-3.5 text-urb-primary shrink-0" />
                    Receitas e pagamentos
                  </li>
                  <li className="flex items-center gap-2">
                    <Check className="w-3.5 h-3.5 text-urb-primary shrink-0" />
                    Check-ins realizados
                  </li>
                  <li className="flex items-center gap-2">
                    <Check className="w-3.5 h-3.5 text-urb-primary shrink-0" />
                    Gráficos avançados
                  </li>
                  <li className="flex items-center gap-2">
                    <Check className="w-3.5 h-3.5 text-urb-primary shrink-0" />
                    Exportação de dados
                  </li>
                </ul>
              </div>
              <div className="flex-1 flex items-center justify-center">
                <div className="p-4 rounded-xl border border-slate-800 bg-slate-950/80 w-full flex flex-col gap-2">
                  <span className="font-bold text-white text-xs block pb-1 border-b border-slate-800">
                    Inscrições
                  </span>
                  <div className="flex justify-between text-xs">
                    <span className="text-slate-400">Total:</span>
                    <span className="font-bold text-white">2.431</span>
                  </div>
                  <div className="flex justify-between text-xs">
                    <span className="text-slate-400">Receita:</span>
                    <span className="font-bold text-urb-primary">
                      R$ 98.670,00
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* 02. Check-in Inteligente */}
            <div className="bg-urb-card/70 border border-urb-border hover:border-urb-primary/50 transition-all duration-300 rounded-2xl p-6 flex flex-col md:flex-row gap-6">
              <div className="flex-1 flex flex-col gap-3">
                <span className="inline-block px-3 py-1 rounded-full bg-urb-primary/10 border border-urb-primary/30 text-urb-primary font-mono text-xs font-bold w-fit">
                  02. CHECK-IN INTELIGENTE
                </span>
                <p className="text-xs text-slate-400 m-0">
                  QR Code dinâmico para check-in rápido, seguro e sem filas.
                </p>
                <ul className="flex flex-col gap-2 p-0 m-0 list-none text-xs text-slate-200">
                  <li className="flex items-center gap-2">
                    <Check className="w-3.5 h-3.5 text-urb-primary shrink-0" />
                    Leitura via app ou web
                  </li>
                  <li className="flex items-center gap-2">
                    <Check className="w-3.5 h-3.5 text-urb-primary shrink-0" />
                    Modo offline
                  </li>
                  <li className="flex items-center gap-2">
                    <Check className="w-3.5 h-3.5 text-urb-primary shrink-0" />
                    Validação em tempo real
                  </li>
                  <li className="flex items-center gap-2">
                    <Check className="w-3.5 h-3.5 text-urb-primary shrink-0" />
                    Retirada de kit
                  </li>
                  <li className="flex items-center gap-2">
                    <Check className="w-3.5 h-3.5 text-urb-primary shrink-0" />
                    Controle de presença
                  </li>
                </ul>
              </div>
              <div className="flex-1 flex items-center justify-center gap-3">
                <div className="flex flex-col items-center justify-center p-3 rounded-xl border border-slate-800 bg-slate-950/80 w-28 h-32">
                  <span className="text-[10px] text-white font-bold mb-1">
                    Check-in
                  </span>
                  <QrCode className="w-12 h-12 my-1 text-urb-primary" />
                  <span className="text-[9px] text-urb-primary font-bold mt-1 tracking-wider uppercase">
                    REALIZADO
                  </span>
                </div>
                <div className="p-3 rounded-xl flex flex-col items-center justify-center text-center bg-urb-primary text-black w-24 h-32">
                  <span className="font-black text-xs">URB STAFF</span>
                  <span className="text-[10px] font-bold mt-2 border border-black px-2 py-0.5 rounded">
                    OPERADOR
                  </span>
                </div>
              </div>
            </div>

            {/* 03. Inscrições Flexíveis */}
            <div className="bg-urb-card/70 border border-urb-border hover:border-urb-primary/50 transition-all duration-300 rounded-2xl p-6 flex flex-col md:flex-row gap-6">
              <div className="flex-1 flex flex-col gap-3">
                <span className="inline-block px-3 py-1 rounded-full bg-urb-primary/10 border border-urb-primary/30 text-urb-primary font-mono text-xs font-bold w-fit">
                  03. INSCRIÇÕES FLEXÍVEIS
                </span>
                <p className="text-xs text-slate-400 m-0">
                  Crie lotes, tipos de ingressos e categorias personalizadas.
                </p>
                <ul className="flex flex-col gap-2 p-0 m-0 list-none text-xs text-slate-200">
                  <li className="flex items-center gap-2">
                    <Check className="w-3.5 h-3.5 text-urb-primary shrink-0" />
                    Lotes com quantidade ou data
                  </li>
                  <li className="flex items-center gap-2">
                    <Check className="w-3.5 h-3.5 text-urb-primary shrink-0" />
                    Cupons de desconto
                  </li>
                  <li className="flex items-center gap-2">
                    <Check className="w-3.5 h-3.5 text-urb-primary shrink-0" />
                    Formulários personalizados
                  </li>
                  <li className="flex items-center gap-2">
                    <Check className="w-3.5 h-3.5 text-urb-primary shrink-0" />
                    Tipos de ingresso
                  </li>
                  <li className="flex items-center gap-2">
                    <Check className="w-3.5 h-3.5 text-urb-primary shrink-0" />
                    Transferência de inscrição
                  </li>
                </ul>
              </div>
              <div className="flex-1 flex flex-col justify-center">
                <div className="p-3.5 rounded-xl border border-slate-800 bg-slate-950/80 flex flex-col gap-2.5">
                  <div className="flex justify-between text-xs font-bold text-white pb-1.5 border-b border-slate-800">
                    <span>Lotes de Inscrição</span>
                  </div>
                  <div className="flex justify-between text-xs text-slate-400">
                    <span>1º Lote Promo</span>
                    <span className="text-white font-semibold">R$ 79,90</span>
                  </div>
                  <div className="flex justify-between text-xs text-slate-400">
                    <span>2º Lote</span>
                    <span className="text-white font-semibold">R$ 99,90</span>
                  </div>
                  <Button variant="primary" size="sm" className="w-full text-xs font-bold mt-1 uppercase">
                    CRIAR NOVO LOTE
                  </Button>
                </div>
              </div>
            </div>

            {/* 04. Pagamentos Automáticos */}
            <div className="bg-urb-card/70 border border-urb-border hover:border-urb-primary/50 transition-all duration-300 rounded-2xl p-6 flex flex-col md:flex-row gap-6">
              <div className="flex-1 flex flex-col gap-3">
                <span className="inline-block px-3 py-1 rounded-full bg-urb-primary/10 border border-urb-primary/30 text-urb-primary font-mono text-xs font-bold w-fit">
                  04. PAGAMENTOS AUTOMÁTICOS
                </span>
                <p className="text-xs text-slate-400 m-0">
                  Receba pagamentos online com segurança e repasse automático.
                </p>
                <ul className="flex flex-col gap-2 p-0 m-0 list-none text-xs text-slate-200">
                  <li className="flex items-center gap-2">
                    <Check className="w-3.5 h-3.5 text-urb-primary shrink-0" />
                    Cartão de crédito, PIX e Boleto
                  </li>
                  <li className="flex items-center gap-2">
                    <Check className="w-3.5 h-3.5 text-urb-primary shrink-0" />
                    Split automático e repasse
                  </li>
                  <li className="flex items-center gap-2">
                    <Check className="w-3.5 h-3.5 text-urb-primary shrink-0" />
                    Relatórios financeiros consolidados
                  </li>
                </ul>
              </div>
              <div className="flex-1 flex flex-col justify-center">
                <div className="p-3.5 rounded-xl border border-slate-800 bg-slate-950/80 flex flex-col gap-1.5 text-xs">
                  <div className="flex justify-between text-slate-400">
                    <span>Receita Total:</span>
                    <span className="text-white font-semibold">R$ 98.670,00</span>
                  </div>
                  <div className="flex justify-between text-slate-400 border-b border-slate-800 pb-1.5">
                    <span>Taxas URB:</span>
                    <span className="text-red-400 font-semibold">- R$ 6.123,20</span>
                  </div>
                  <div className="flex justify-between text-white font-bold pt-1">
                    <span>Líquido:</span>
                    <span className="text-urb-primary font-bold">R$ 92.546,80</span>
                  </div>
                  <div className="flex justify-between text-[11px] text-slate-400 pt-1.5 border-t border-slate-800">
                    <span>Repasse via PIX:</span>
                    <span className="text-emerald-400 font-bold uppercase">Agendado</span>
                  </div>
                </div>
                <div className="flex items-center justify-center gap-3 text-xs text-slate-400 mt-2 font-mono">
                  <CreditCard className="w-4 h-4 text-slate-500" />
                  <span className="font-bold">VISA</span>
                  <span className="font-bold">PIX</span>
                  <span className="font-bold">BOLETO</span>
                </div>
              </div>
            </div>

            {/* 05. Comunicação Automática */}
            <div className="bg-urb-card/70 border border-urb-border hover:border-urb-primary/50 transition-all duration-300 rounded-2xl p-6 flex flex-col md:flex-row gap-6">
              <div className="flex-1 flex flex-col gap-3">
                <span className="inline-block px-3 py-1 rounded-full bg-urb-primary/10 border border-urb-primary/30 text-urb-primary font-mono text-xs font-bold w-fit">
                  05. COMUNICAÇÃO AUTOMÁTICA
                </span>
                <p className="text-xs text-slate-400 m-0">
                  Engaje atletas com comunicação inteligente e automatizada.
                </p>
                <ul className="flex flex-col gap-2 p-0 m-0 list-none text-xs text-slate-200">
                  <li className="flex items-center gap-2">
                    <Check className="w-3.5 h-3.5 text-urb-primary shrink-0" />
                    E-mails automáticos de status
                  </li>
                  <li className="flex items-center gap-2">
                    <Check className="w-3.5 h-3.5 text-urb-primary shrink-0" />
                    WhatsApp integrado ao fluxo
                  </li>
                  <li className="flex items-center gap-2">
                    <Check className="w-3.5 h-3.5 text-urb-primary shrink-0" />
                    SMS e notificações pré-corrida
                  </li>
                  <li className="flex items-center gap-2">
                    <Check className="w-3.5 h-3.5 text-urb-primary shrink-0" />
                    Lembretes e avisos importantes
                  </li>
                </ul>
              </div>
              <div className="flex-1 flex items-center justify-center">
                <div className="p-3.5 rounded-xl border border-slate-800 bg-[#0b141a] flex flex-col gap-2 w-full max-w-[240px]">
                  <div className="flex items-center gap-2 border-b border-slate-800 pb-2">
                    <div className="w-6 h-6 rounded-full bg-urb-primary flex items-center justify-center text-black font-black text-[10px]">
                      URB
                    </div>
                    <span className="text-white font-bold text-xs">URB RACE</span>
                  </div>
                  <div className="bg-[#1f2c34] p-2 rounded-lg text-slate-200 text-[10px] leading-relaxed">
                    Olá, João! Sua inscrição no URB Night Run está confirmada.
                  </div>
                  <div className="bg-[#1f2c34] p-2 rounded-lg text-slate-200 text-[10px] leading-relaxed">
                    Retirada de kit: 24/05 das 10h às 20h. Local: Expo Center.
                  </div>
                </div>
              </div>
            </div>

            {/* 06. Resultados e Rankings */}
            <div className="bg-urb-card/70 border border-urb-border hover:border-urb-primary/50 transition-all duration-300 rounded-2xl p-6 flex flex-col md:flex-row gap-6">
              <div className="flex-1 flex flex-col gap-3">
                <span className="inline-block px-3 py-1 rounded-full bg-urb-primary/10 border border-urb-primary/30 text-urb-primary font-mono text-xs font-bold w-fit">
                  06. RESULTADOS E RANKINGS
                </span>
                <p className="text-xs text-slate-400 m-0">
                  Resultados instantâneos e rankings atualizados em tempo real.
                </p>
                <ul className="flex flex-col gap-2 p-0 m-0 list-none text-xs text-slate-200">
                  <li className="flex items-center gap-2">
                    <Check className="w-3.5 h-3.5 text-urb-primary shrink-0" />
                    Resultados por tempo líquido
                  </li>
                  <li className="flex items-center gap-2">
                    <Check className="w-3.5 h-3.5 text-urb-primary shrink-0" />
                    Certificados automáticos
                  </li>
                  <li className="flex items-center gap-2">
                    <Check className="w-3.5 h-3.5 text-urb-primary shrink-0" />
                    Rankings geral e categorias
                  </li>
                  <li className="flex items-center gap-2">
                    <Check className="w-3.5 h-3.5 text-urb-primary shrink-0" />
                    Compartilhamento rápido
                  </li>
                </ul>
              </div>
              <div className="flex-1 flex flex-col justify-center">
                <div className="p-3.5 rounded-xl border border-slate-800 bg-slate-950/80 flex flex-col gap-2 text-xs">
                  <div className="font-bold text-white border-b border-slate-800 pb-1.5 mb-0.5">
                    TOP 5 GERAL - 10K
                  </div>
                  <div className="flex justify-between text-slate-400">
                    <span>1. João da Silva</span>
                    <span className="text-urb-primary font-bold">00:34:21</span>
                  </div>
                  <div className="flex justify-between text-slate-400">
                    <span>2. Carlos Lima</span>
                    <span className="text-white">00:35:10</span>
                  </div>
                  <div className="flex justify-between text-slate-400">
                    <span>3. Pedro Santos</span>
                    <span className="text-white">00:36:45</span>
                  </div>
                  <Button variant="primary" size="sm" className="w-full text-xs font-bold mt-1 uppercase">
                    VER RESULTADOS
                  </Button>
                </div>
              </div>
            </div>

            {/* 07. Certificados Automáticos */}
            <div className="bg-urb-card/70 border border-urb-border hover:border-urb-primary/50 transition-all duration-300 rounded-2xl p-6 flex flex-col md:flex-row gap-6">
              <div className="flex-1 flex flex-col gap-3">
                <span className="inline-block px-3 py-1 rounded-full bg-urb-primary/10 border border-urb-primary/30 text-urb-primary font-mono text-xs font-bold w-fit">
                  07. CERTIFICADOS AUTOMÁTICOS
                </span>
                <p className="text-xs text-slate-400 m-0">
                  Envio automático de certificados personalizados para os atletas.
                </p>
                <ul className="flex flex-col gap-2 p-0 m-0 list-none text-xs text-slate-200">
                  <li className="flex items-center gap-2">
                    <Check className="w-3.5 h-3.5 text-urb-primary shrink-0" />
                    Certificado com tempo oficial
                  </li>
                  <li className="flex items-center gap-2">
                    <Check className="w-3.5 h-3.5 text-urb-primary shrink-0" />
                    Personalização do layout
                  </li>
                  <li className="flex items-center gap-2">
                    <Check className="w-3.5 h-3.5 text-urb-primary shrink-0" />
                    Envio por e-mail e download
                  </li>
                  <li className="flex items-center gap-2">
                    <Check className="w-3.5 h-3.5 text-urb-primary shrink-0" />
                    QR Code de validação
                  </li>
                </ul>
              </div>
              <div className="flex-1 flex items-center justify-center">
                <div className="p-4 rounded-xl border border-slate-300 bg-white text-slate-900 text-center w-full max-w-xs flex flex-col gap-2 shadow-lg">
                  <span className="font-black text-[10px] uppercase tracking-wider text-slate-700">
                    CERTIFICADO
                  </span>
                  <span className="text-[10px] text-slate-500">Concluído com sucesso por</span>
                  <span className="font-extrabold text-xs text-black">João da Silva</span>
                  <div className="border-y border-slate-200 py-1.5 my-1 flex justify-center gap-6 text-[10px]">
                    <div>
                      <div className="text-slate-400">Modalidade</div>
                      <div className="font-bold text-slate-800">10K</div>
                    </div>
                    <div>
                      <div className="text-slate-400">Tempo Oficial</div>
                      <div className="font-bold text-slate-800">00:34:21</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 08. Integrações */}
            <div className="bg-urb-card/70 border border-urb-border hover:border-urb-primary/50 transition-all duration-300 rounded-2xl p-6 flex flex-col md:flex-row gap-6">
              <div className="flex-1 flex flex-col gap-3">
                <span className="inline-block px-3 py-1 rounded-full bg-urb-primary/10 border border-urb-primary/30 text-urb-primary font-mono text-xs font-bold w-fit">
                  08. INTEGRAÇÕES
                </span>
                <p className="text-xs text-slate-400 m-0">
                  Conecte a URB RACE com outras ferramentas e serviços.
                </p>
                <ul className="flex flex-col gap-2 p-0 m-0 list-none text-xs text-slate-200">
                  <li className="flex items-center gap-2">
                    <Check className="w-3.5 h-3.5 text-urb-primary shrink-0" />
                    WhatsApp Business
                  </li>
                  <li className="flex items-center gap-2">
                    <Check className="w-3.5 h-3.5 text-urb-primary shrink-0" />
                    Google Maps & Localização
                  </li>
                  <li className="flex items-center gap-2">
                    <Check className="w-3.5 h-3.5 text-urb-primary shrink-0" />
                    Strava Integration
                  </li>
                  <li className="flex items-center gap-2">
                    <Check className="w-3.5 h-3.5 text-urb-primary shrink-0" />
                    ZapSign e assinatura eletrônica
                  </li>
                  <li className="flex items-center gap-2">
                    <Check className="w-3.5 h-3.5 text-urb-primary shrink-0" />
                    APIs robustas e Webhooks
                  </li>
                </ul>
              </div>
              <div className="flex-1 flex flex-wrap gap-2 items-center justify-center">
                {["WhatsApp", "Google Maps", "Strava", "ZapSign", "APIs"].map((tag, idx) => (
                  <span
                    key={idx}
                    className="text-xs px-3 py-1.5 rounded-lg font-bold bg-slate-950/80 border border-slate-800 text-slate-300"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Security Section */}
        <section className="py-8 px-4 md:px-8 border-y border-urb-border bg-slate-950/40">
          <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center justify-between gap-6">
            <div className="flex flex-col gap-1 text-center lg:text-left">
              <span className="font-bold text-xs uppercase text-urb-primary tracking-wider">
                SEGURANÇA E CONFIANÇA
              </span>
              <span className="text-slate-400 text-sm">
                Seus dados e os dos atletas sempre protegidos.
              </span>
            </div>
            <div className="flex flex-wrap gap-6 justify-center">
              {[
                { title: "LGPD", desc: "Conformidade total", icon: Lock },
                { title: "Criptografia", desc: "Dados protegidos", icon: Key },
                { title: "Backups diários", desc: "Segurança contínua", icon: Database },
                { title: "Infraestrutura", desc: "Alta performance", icon: Server },
                { title: "Monitoramento 24/7", desc: "Ambiente seguro", icon: Eye },
              ].map((item, idx) => {
                const Icon = item.icon;
                return (
                  <div key={idx} className="flex items-center gap-2.5">
                    <div className="w-8 h-8 rounded-lg bg-urb-primary/10 border border-urb-primary/30 flex items-center justify-center">
                      <Icon className="w-4 h-4 text-urb-primary" />
                    </div>
                    <div className="flex flex-col">
                      <span className="text-white font-bold text-xs">{item.title}</span>
                      <span className="text-slate-400 text-[10px]">{item.desc}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* Bottom CTA */}
        <section className="py-8 px-4 md:px-8 max-w-5xl mx-auto my-8">
          <div className="bg-gradient-to-r from-slate-900 via-urb-card to-slate-900 border border-urb-border rounded-3xl p-6 sm:p-10 flex flex-col md:flex-row items-center justify-between gap-6 shadow-2xl relative overflow-hidden">
            <div className="flex flex-col gap-3 relative z-10 text-center md:text-left">
              <h2 className="text-2xl sm:text-3xl font-black text-white leading-tight">
                TECNOLOGIA QUE TRANSFORMA EVENTOS. <br />
                <span className="text-urb-primary">FOCO NO QUE IMPORTA.</span>
              </h2>
              <p className="m-0 text-slate-300 text-sm max-w-lg leading-relaxed">
                Experiências inesquecíveis geradas de ponta a ponta pela plataforma líder de corridas de rua.
              </p>
            </div>
            <div className="relative z-10 w-full md:w-auto">
              <Button
                variant="primary"
                size="lg"
                className="w-full md:w-auto font-black text-sm uppercase px-8 py-3.5 tracking-wider shadow-lg flex items-center justify-center gap-2"
              >
                CRIAR MEU EVENTO AGORA
                <ArrowRight className="w-4 h-4 ml-1" />
              </Button>
            </div>
          </div>
        </section>
      </main>

      <LandingFooter />
    </div>
  );
}

export default Recursos;
